import { useMutation } from '@tanstack/react-query';
import {
  startEmailReplacement,
  verifyCurrentEmailOtp,
  verifyNewEmailOtp,
} from '@/api/email-replacement.api';

/** Step 1: submit the candidate company email (FR-14, MYN-76). */
export function useStartEmailReplacement() {
  return useMutation({ mutationFn: startEmailReplacement });
}

/** Step 2: verify the OTP sent to the current email. */
export function useVerifyCurrentEmailOtp() {
  return useMutation({
    mutationFn: ({ requestId, code }: { requestId: string; code: string }) =>
      verifyCurrentEmailOtp(requestId, code),
  });
}

/** Step 3: verify the OTP sent to the new email, completing the swap. */
export function useVerifyNewEmailOtp() {
  return useMutation({
    mutationFn: ({ requestId, code }: { requestId: string; code: string }) =>
      verifyNewEmailOtp(requestId, code),
  });
}
